import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import { ToggleWrapper, OptionButton } from './styled';

const StoreToggle = ({ selectedStore, setSelectedStore }) => {
  const { messages } = useIntl();

  return (
    <ToggleWrapper>
      <OptionButton
        selected={selectedStore === 'GOOGLE_PLAY'}
        onClick={() => setSelectedStore('GOOGLE_PLAY')}
      >
        <input
          type="radio"
          value="GOOGLE_PLAY"
          name="selectedStore"
          defaultChecked
        />
        <img
          src={messages['global.qrcodeModal.google-play.img']}
          alt="google-play"
        />
        <FormattedMessage
          id="global.qrcodeModal.google-play.title"
          tagName="span"
        />
      </OptionButton>
      <OptionButton
        selected={selectedStore === 'APP_STORE'}
        onClick={() => setSelectedStore('APP_STORE')}
      >
        <input type="radio" value="APP_STORE" name="selectedStore" />
        <img
          src={
            selectedStore === 'APP_STORE'
              ? '/images/uploads/apple_new_2_selected.svg'
              : '/images/uploads/apple_new_2.svg'
          }
          alt="app-store"
        />
        <FormattedMessage
          id="global.qrcodeModal.app-store.title"
          tagName="span"
        />
      </OptionButton>
    </ToggleWrapper>
  );
};

StoreToggle.propTypes = {
  selectedStore: PropTypes.string,
  setSelectedStore: PropTypes.func.isRequired,
};

StoreToggle.defaultProps = {
  selectedStore: 'GOOGLE_PLAY',
};

export default StoreToggle;
